import { render, staticRenderFns } from "./PredictionsList.vue?vue&type=template&id=89ba5836&scoped=true&"
import script from "./PredictionsList.vue?vue&type=script&lang=js&"
export * from "./PredictionsList.vue?vue&type=script&lang=js&"
import style0 from "./PredictionsList.vue?vue&type=style&index=0&id=89ba5836&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ba5836",
  null
  
)

export default component.exports